import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { SalaryContractCostSection } from '../../../-shared/SalaryContractCostSection';
import { salaryContractCostSearchSchema, type SalaryContractCostSearch } from '../../../-shared/searchSchema';
export const Route = createFileRoute('/_staff/salary-and-wages/_layout/contract-and-cost/_contract-and-cost/cost/$period/')({
  component: SalaryCostOverviewPage,
  validateSearch: zodValidator(salaryContractCostSearchSchema)
});
function SalaryCostOverviewPage() {
  const {
    period
  } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <SalaryContractCostSection section="cost" period={period} search={search} onSearchUpdate={(next: Partial<SalaryContractCostSearch>) => navigate({
    search: prev => ({
      ...prev,
      ...next
    }),
    replace: true
  })} />;
}